export default __webpack_public_path__ + "static/media/prev-E1A-4.582d1e3e.png";